module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/5-a47aad6ccd720d443834ca569f0786d6.png";